export const APP_VERSION = 'v1.00.06'
export const APP_ANDROID_VERSION = `${APP_VERSION}.a`
export const APP_IOS_VERSION = `${APP_VERSION}.i`
export const MDW_ENDPOINT = import.meta.env.VITE_MDW_ENDPOINT ? import.meta.env.VITE_MDW_ENDPOINT : 'https://app.inm.pt/BAICV-MDW-DEV/internet-banking/api/internet/'
export const MDW_PORTAL_ENDPOINT = import.meta.env.VITE_MDW_PORTAL_ENDPOINT ? import.meta.env.VITE_MDW_PORTAL_ENDPOINT : 'https://app.inm.pt/BAICV-MDW-DEV/portal/api/internet/'

export const USER_SESSION = 'bai-v4-user-session'

export const ACCOUNT_GROUPS_COLLORS = []
export const PATRIMONY_COLORS = ['#614DDB', '#CF59CD', '#F57723', '#EB9B00', '#FECF01', '#AF8D47', '#8C58D6', '#AD58D2', '#DC6395', '#E86D5C', '#F28318', '#EE8F0C', '#F2AD00', '#F8BE01', '#E4BA18', '#CAA330', '#987B78', '#8169AA']
export const PATRIMONY_COLORS_DARK = ['#6255AD', '#9C579A', '#BF7848', '#CC952A', '#D0B53D', '#C29A49', '#7556A7', '#8956A0', '#A8627F', '#B36D63', '#C3823E', '#C88B34', '#CDA030', '#CFAA37', '#CBAC41', '#C7A345', '#A2836A', '#826C8C']

export const HEADER_GRADIENTS = {
    'default-gradient': '--blue-gradient',
    'info-gradient': '--success-gradient',
    'warning-gradient': '--warning-gradient',
    'error-gradient': '--error-gradient',
    'generic-card-background-color': '--generic-background-color',
    'platinum-card-background-color': '--platinum-background-color',
    'classic-card-background-color': '--classic-background-color',
    'gold-card-background-color': '--gold-background-color',
    'kriola-card-background-color': '--kriola-background-color',
    'kriola-business-card-background-color': '--kriola-business-background-color',
    'na-card-background-color': '--na-background-color',
    'prestige-business-card-background-color': '--prestige-business-background-color',
    'particular-debit-card-background-color': '--particular-debit-background-color',
    'particular-prestige-card-background-color': '--particular-prestige-background-color',
    'teamcv-prepaid-card-background-color': '--teamcv-background-color',
    'debit-business-card-background-color': '--debit-business-background-color'
}

export const BANKASSURANCE_PRODUCTS = {
    TRAVEL: 'TRAVEL',
    AUTO: 'AUTO',
    HEALTH: 'HEALTH'
}
